<template lang="pug">
  WtEntityTable#challenges-table(
    title="All Program Challenges"
    has-large-title
    :data="validChallengesData"
    default-sort-field="competition_enddate"
    empty-message="No challenges have been added yet."
    :showEmptyMessage="!loading"
  )
    BTableColumn(
      field="name"
      label="Challenge Name"
      sortable
      v-slot="column"
    )
      .columns
        .column
          BTooltip(
            label="View this challenge"
            position="is-top"
            animated
          )
            WtRouterLink(
              to="Challenge"
              :params="{ challengeId: column.row.id }"
              :text="column.row.name"
              type="table"
            )
        .column.is-1
          WtRouterLink(
            v-if="showChallengeEditButton(column.row)"
            :to="$auth.user().isAdmin ? 'ChallengeEditAdmin' : 'ChallengeEditMember'"
            :params="{ challengeId: column.row.id.toString() }"
            type="table"
          )
            BTooltip(
              slot="icon"
              :label="`Edit: ${column.row.name}`"
              position="is-top"
              animated
            )
              BIcon(icon="settings" size="is-small")
    BTableColumn(
      field="between"
      label="Type"
      sortable
      v-slot="column"
    )
      | {{ challengeType(column.row) }}
    BTableColumn(
      field="startDate"
      label="Start Date"
      sortable
      v-slot="column"
    )
      | {{ date(column.row.startDate, "DATE_FORMAT_SLASH").formatted }}
    BTableColumn(
      field="endDate"
      label="End Date"
      sortable
      v-slot="column"
    )
      | {{ date(column.row.endDate, "DATE_FORMAT_SLASH").formatted }}
    BTableColumn(
      field="joined"
      label="Joined"
      v-slot="column"
    )
      ChallengeJoinButton(:challenge="column.row")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import tablePropsMixin from "@/mixins/tablePropsMixin";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { challengeMixin } from "@/mixins/challengeMixin";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import WtButton from "@@/WtButton/WtButton";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import BTooltip from "buefy/src/components/tooltip/Tooltip";
import ChallengeJoinButton from "@@/Challenge/ChallengeJoinButton";

export default {
  name: "ProgramChallengesTable",

  components: {
    WtEntityTable,
    WtButton,
    WtRouterLink,
    BTooltip,
    ChallengeJoinButton
  },

  mixins: [tablePropsMixin, dateUtilityMixin, challengeMixin],

  props: {
    challengesData: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters(["members/challengeInvites"]),

    validChallengesData() {
      return this.challengesData.filter(challenge => this.isValid(challenge));
    }
  },

  methods: {
    ...mapActions("challenges", ["deleteChallenge"]),

    isPublic(challenge) {
      return challenge.public === 1;
    },
    isInvited(challenge) {
      const memberInviteIds = this["members/challengeInvites"].map(
        invite => invite.inviteId
      );

      return (
        memberInviteIds.includes(challenge.id) ||
        this.$auth.user().id === challenge.initiator.id
      );
    },
    isDenied(challenge) {
      const memberDeniedInviteIds = this["members/challengeInvites"]
        .filter(invite => invite.denied)
        .map(invite => invite.inviteId);
      return memberDeniedInviteIds.includes(challenge.id);
    },

    isValid(challenge) {
      return (
        (this.isPublic(challenge) ||
          (!this.isPublic(challenge) && this.isInvited(challenge))) &&
        !this.isDenied(challenge) &&
        !this.isTodayAfterChallengeEnd(challenge) &&
        this.challengeNotEndedForUser(challenge)
      );
    },

    showChallengeEditButton(challenge) {
      if (challenge.isPvsPChallenge) return false;

      let isAdmin =
        challenge.initiator.id === this.$auth.user().id ||
        this.$auth.user().isAdmin;

      return isAdmin;
    },
    challengeNotEndedForUser(challenge) {
      const COMPLETED = 2;
      return challenge.status !== COMPLETED;
    }
  }
};
</script>

<style lang="sass" scoped></style>
